import React, { Component } from 'react';
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import { 
  PostContainer,
  PageIntro,
  PostDate, 
  CvContainer,
  CvItem,
  CvTitle,
  CvPlace,
  CvDate,
  CvContent,
  CvCategory,
  CvLink,
  CvWrapper,
  CvNav,
  CvButton,
  CvAnchor,
  shevy,
  NoPrint,
  OnlyPrint,
} from '../components/StyledComponents'
import Sticky from "react-stickynode"
import ScrollableAnchor, {configureAnchors} from 'react-scrollable-anchor'

configureAnchors({
  offset: -100,
  scrollDuration: 400
})

export class PostSingle extends Component {

  render() {
    const { data } = this.props;
    return (
      <div>
        <CvWrapper>
          <NoPrint>
            <CvNav>
              <h1>C.V.</h1>

              <Sticky enabled={true} top={100}>
              {
                data.categories.edges.map(({node}) => 
                  <CvAnchor key={node.id} href={`#${node.frontmatter.value}`}>{node.frontmatter.title} →</CvAnchor>
                )
              }

              </Sticky>
            </CvNav>
          </NoPrint>
          <div>
            <OnlyPrint>
             <h1>{data.site.siteMetadata.title} - C.V.</h1>
            </OnlyPrint>
            {
              data.categories.edges.map(({node}) => 
                <ScrollableAnchor key={node.id} id={node.frontmatter.value}>
                  <CvContainer>
                    <CvCategory>{node.frontmatter.title}</CvCategory>
                      {
                        data.items.edges
                        .filter(cvItem => 
                          cvItem.node.frontmatter.category.toLowerCase() === node.frontmatter.value.toLowerCase()
                        )
                        .map(cvItem => (
                          <CvItem key={cvItem.node.id}>

                            { cvItem.node.frontmatter.file !== "" &&
                              cvItem.node.frontmatter.file !== undefined &&
                              cvItem.node.frontmatter.file !== null 
                                ? <CvLink href={cvItem.node.frontmatter.file}><CvTitle>{cvItem.node.frontmatter.title}</CvTitle></CvLink>
                                : <CvTitle>{cvItem.node.frontmatter.title}</CvTitle>
                            }
                            
                            { cvItem.node.frontmatter.category.toLowerCase() !== 'education' &&
                            <CvDate>
                              { cvItem.node.frontmatter.start_date !== null &&
                                cvItem.node.frontmatter.start_date !== undefined &&
                                cvItem.node.frontmatter.start_date !== "" && 
                                  <span>{cvItem.node.frontmatter.start_date}</span>
                              }
                              
                              { cvItem.node.frontmatter.start_date &&
                                (cvItem.node.frontmatter.end_date || cvItem.node.frontmatter.current) &&
                                  <span>&nbsp;&mdash;&nbsp;</span>
                              }

                              { cvItem.node.frontmatter.end_date !== null &&
                                cvItem.node.frontmatter.end_date !== undefined &&
                                cvItem.node.frontmatter.end_date !== "" && 
                                  <span>{cvItem.node.frontmatter.end_date}</span>
                              }
                              
                              { cvItem.node.frontmatter.current && 
                                <span>Current</span>
                              }
                            </CvDate>
                          }

                            <CvPlace>{cvItem.node.frontmatter.place}</CvPlace>

                            <NoPrint>
                              <CvContent 
                                dangerouslySetInnerHTML={{
                                  __html: cvItem.node.html
                                }} 
                              />
                            </NoPrint>
                          </CvItem>
                        ))
                      }
                  </CvContainer>
                </ScrollableAnchor>
              )
            }
          </div>
        </CvWrapper>
      </div>
    );
  }
}

export default PostSingle;

export const query = graphql`
  query CVItemsAndCategories
  {
    site {
      siteMetadata {
        title
        description
      }
    }
    categories: allMarkdownRemark(sort: {fields: [frontmatter___order], order: ASC}, filter: {frontmatter: {templateKey: {eq: "CVCategoryTemplate"}}}) {
      edges {
        node {
          id
          frontmatter {
            title
            value
            order
          }
        }
      }
    }
    items: allMarkdownRemark(sort: {fields: [frontmatter___order], order: DESC}, filter: {frontmatter: {templateKey: {eq: "CVItemTemplate"}}}) {
      edges {
        node {
          id
          excerpt
          fields {
            slug
          }
          frontmatter {
            start_date(formatString: "MMMM YYYY")
            end_date(formatString: "MMMM YYYY")
            title
            subtitle
            place
            current
            file
            date(formatString: "MMM DD, YYYY")
            category
          }
          html
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/Resume.js